<script setup lang="ts">
// App component now uses router-view
</script>

<template>
  <div>
    <router-view />
  </div>
</template>

<style scoped>

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
/* Add any additional styles here */
</style>
